import { render, staticRenderFns } from "./EmployeePagination.vue?vue&type=template&id=158db42c&"
import script from "./EmployeePagination.vue?vue&type=script&lang=js&"
export * from "./EmployeePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports